import { CurrencyConfig } from '../types/currency'

export const DOMAIN_CURRENCY_MAP: Record<string, CurrencyConfig> = {
    'ae.flyin.com': { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'meae.flyin.com': { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'www.cleartrip.ae': { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'me.cleartrip.ae': { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    localhost: { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },

    'bh.cleartrip.com': { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'qa2bh.cleartrip.com': { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'bh.cleartrip.sa': { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'www.cleartrip.bh': { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },

    'om.cleartrip.com': { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'qa2om.cleartrip.com': { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'om.cleartrip.sa': { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'www.cleartrip.om': { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },

    'kw.cleartrip.com': { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'qa2kw.cleartrip.com': { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'kw.cleartrip.sa': { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'www.cleartrip.com.kw': { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'www.cleartrip.kw': { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },

    'qa.cleartrip.com': { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'qa2qa.cleartrip.com': { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'qar.cleartrip.sa': { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'www.cleartrip.qa': { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },

    'www.cleartrip.sa': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'me.flyin.com': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'www.flyin.com': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'heya.flyin.com': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'me-heya.flyin.com': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },

    'me.cleartrip.sa': { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },

    'me.cleartrip.com': { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
    'qa2me.cleartrip.com': { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
    'www.cleartrip.me': { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },

    'www.cleartrip.eu': { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' },
    'eg.flyin.com': { locale: 'EG', currency: 'EGP', country: 'FEG', symbol: 'EGP' },
    'meeg.flyin.com': { locale: 'EG', currency: 'EGP', country: 'FEG', symbol: 'EGP' },
    'www.cleartrip.pl': { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' },
    'www.cleartrip.co.za': { locale: 'ZA', currency: 'ZAR', country: 'ZA', symbol: 'R' }
}

export const CURRENCY_PRECISION_MAP: Record<string, number> = {
    KWD: 2,
    USD: 2,
    INR: 0,
    AED: 0,
    SAR: 0,
    BHD: 2
}

// Locale mapping
export const CURRENCY_LOCALE_MAP: Record<string, string> = {
    AED: 'en-AE',
    OMR: 'en-OM',
    KWD: 'en-KW',
    BHD: 'en-BH',
    SAR: 'en-SA',
    USD: 'en-US',
    QAR: 'en-QA'
}
